import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      backgroundColor: UIKIT_COLORS.WHITE,
      border: `1px solid ${UIKIT_COLORS.BORDER}`,
      borderRadius: 12,
      boxShadow: "0px 1px 2px 0px rgba(0,0,0,0.05)",
      width: "100%",
      boxSizing: "border-box",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: UIKIT_COLORS.BG_LIGHT,
      borderBottom: `1px solid ${UIKIT_COLORS.BORDER}`,
      padding: "16px 24px 17px",
      borderRadius: "12px 12px 0 0",
    },
    headerLeft: {
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
    },
    headerAction: {
      flex: 1,
      minWidth: 0,
      marginLeft: 16,
      overflow: "hidden",
      display: "flex",
      justifyContent: "flex-end",
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      lineHeight: "24px",
      margin: 0,
    },
    subtitle: {
      fontSize: 12,
      fontWeight: 400,
      color: UIKIT_COLORS.TEXT_SECONDARY,
      lineHeight: "16px",
      margin: 0,
      marginTop: 4,
    },
    body: {
      padding: 24,
      width: "100%",
      boxSizing: "border-box",
      "& > * + *": { marginTop: 24 },
    },
  })
);
